import script from "./ChevronRightIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChevronRightIcon.vue?vue&type=script&setup=true&lang=js"

import "./ChevronRightIcon.vue?vue&type=style&index=0&id=0d71f470&lang=scss"

export default script